export interface RouteMetaConfig {
  image?: string;
  title?: string;
  description?: string;
  imageWidth?: number;
  imageHeight?: number;
}

// Map routes to their Open Graph images and metadata
// Update this file to change meta tags for all routes (both client and server)
export const routeMetaMap: Record<string, RouteMetaConfig> = {
  '/dashboard': {
    image: 'https://aptiveindex.nyc3.cdn.digitaloceanspaces.com/screenshots/Dashboard.webp',
    title: 'Dashboard - Aptive Index',
    description: 'Aptive Index Dashboard',
    imageWidth: 1214,
    imageHeight: 682
  },
  '/analytics': {
    image: 'https://aptiveindex.nyc3.cdn.digitaloceanspaces.com/screenshots/Dashboard.webp',
    title: 'Analytics - Aptive Index',
    description: 'Organization analytics: assessments, archetypes, and profiles',
    imageWidth: 1214,
    imageHeight: 682
  },
  '/people': {
    image: 'https://aptiveindex.nyc3.cdn.digitaloceanspaces.com/screenshots/Person%20Details%20-%20Thor.webp',
    title: 'People - Aptive Index',
    description: 'View people and their assessment results in Aptive Index',
    imageWidth: 1214,
    imageHeight: 682
  },
  '/positions': {
    image: 'https://aptiveindex.nyc3.cdn.digitaloceanspaces.com/screenshots/Position%20Details.webp',
    title: 'Positions - Aptive Index',
    description: 'View and manage positions and position details within Aptive Index',
    imageWidth: 1214,
    imageHeight: 682
  },
  '/teams': {
    image: 'https://aptiveindex.nyc3.cdn.digitaloceanspaces.com/screenshots/Team%20Dynamics.webp',
    title: 'Teams - Aptive Index',
    description: 'View and manage teams and team dynamics in Aptive Index',
    imageWidth: 1214,
    imageHeight: 682
  },
  '/folders': {
    image: 'https://aptiveindex.nyc3.cdn.digitaloceanspaces.com/screenshots/aptive-index-assessment-dark-mode-instructions-page.webp',
    title: 'Folders - Aptive Index',
    description: 'View and manage folders and folder contents in Aptive Index',
    imageWidth: 1200,
    imageHeight: 630
  },
  '/profile': {
    image: 'https://aptiveindex.nyc3.cdn.digitaloceanspaces.com/screenshots/aptive-index-assessment-dark-mode-instructions-page.webp',
    title: 'Profile - Aptive Index',
    description: 'View and manage your Aptive Index profile',
    imageWidth: 1200,
    imageHeight: 630
  },
  '/settings': {
    image: 'https://aptiveindex.nyc3.cdn.digitaloceanspaces.com/screenshots/aptive-index-assessment-dark-mode-instructions-page.webp',
    title: 'Settings - Aptive Index',
    description: 'Manage Aptive Index settings',
    imageWidth: 1200,
    imageHeight: 630
  },
  // Aria Chat routes - these will be matched for any /aria/* path or ariachat.ai domains
  '/aria': {
    image: '', // Will be set dynamically based on origin
    title: 'Ask Aria',
    description: 'AI-powered chat assistant for personal growth and development',
    imageWidth: 1200,
    imageHeight: 630
  },
  '/chat': {
    image: '',
    title: 'Ask Aria',
    description: 'AI-powered chat assistant for personal growth and development',
    imageWidth: 1200,
    imageHeight: 630
  },
  // Default fallback
  '/': {
    image: 'https://aptiveindex.nyc3.cdn.digitaloceanspaces.com/screenshots/aptive-index-assessment-dark-mode-instructions-page.webp',
    title: 'Aptive Index',
    description: 'Aptive Index Assessment',
    imageWidth: 1200,
    imageHeight: 630
  }
};

